<template>
    <div id="become-a-hero-now" class="">
        <div class="container">
            <div class="row">
                <div
                    class="col-md-4 col-lg-6  d-sm-none d-md-block"
                    id="cover-img"
                ></div>
                <div class="col-md-8 col-lg-6  col-sm-12" id="details">
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col-10 p-0">
                            <p class="pt-5">
                                Want to have full access to the Wildlife
                                Protector account?
                            </p>
                            <h1
                                class="wwf-font"
                                style="font-size:4em;line-height:1;"
                            >
                                BECOME A WILDLIFE HERO NOW
                            </h1>
                            <p>
                                Become a Wildlife Hero by sponsoring equipment
                                and tools for the field teams to protect
                                threatened species and safeguard their homes!
                            </p>

                            <ul class="list-inline mb-5" v-if="adoptees">
                                <li
                                    class="list-inline-item mr-4 mb-4"
                                    :class="{
                                        active: false
                                    }"
                                    v-for="adoptee in adoptees"
                                    :key="adoptee.id"
                                >
                                    <a
                                        :href="
                                            '/' +
                                                adoptee.slug +
                                                '/adopt/' +
                                                pricing +
                                                '/1'
                                        "
                                        id="bah-btn"
                                    >
                                        <img
                                            width="120"
                                            height="120"
                                            class="rounded-circle"
                                            :src="'/storage/' + adoptee.image"
                                            :alt="adoptee.name"
                                        />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-1"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const pricing_data = {
    price1: 38,
    price2: 48,
    price3: 58
};

export default {
    props: ["adoptee"],
    data() {
        return {
            pricing_data: pricing_data,
            pricing: "price2",
            adoptees: []
        };
    },
    methods: {
        changePricing(pricing) {
            return (this.pricing = pricing);
        }
    },
    mounted() {
        axios.get("/api/v1/adoptees").then(response => {
            this.adoptees = response.data;
        });
    }
};
</script>

<style scoped>
* {
    font-size: 0.9rem;
}
#cover-img {
    background-image: url("/images/pages/Popup_BecomeWildlifeProtector-min.jpg");
    min-height: 100%;
    background-size: cover;
    background-position: center;
}
#details {
    background-color: #000;
    color: #fff;
}
#details .col-12 {
    background-color: #f58220;
    font-size: 2rem;
    color: white;
    padding-bottom: 6px;
}
#details .circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;

    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1;
    text-align: center;
}
#details .circle:hover {
    background-color: #f58220;
    color: white;
    cursor: pointer;
}
.circle-nactive {
    background-color: white;
}
.circle-active {
    background-color: #f58220;
    color: white;
}
#details #monthly {
    margin-top: 20px;
    margin-bottom: 50px;
}
ul {
    list-style: none;
}
ul li {
    margin-top: 10px;
}
ul li[data-v-7fb1fcf2] {
    font-size: 0.9rem;
    font-weight: normal;
    padding-left: 15px !important;
}

#bah-btn:hover {
    cursor: pointer;
    text-decoration: none;
}
@media only screen and (max-width: 600px) {
    #details .circle {
        width: 70px;
        height: 70px;
        font-size: 0.8em;
    }
    #popupSubscription h1.wwf-font {
        font-size: 2.5rem !important;
    }
    #popupSubscription .col-6.p-1 {
        display: contents;
    }
    #popupSubscription ul.pl-0 {
        padding-left: 40px !important;
        margin-bottom: 0px !important;
    }
    #popupSubscription .col-md-12 {
        padding-top: 20px;
    }
    #popupSubscription ul li {
        margin-top: 2px !important;
    }
}
</style>
